
import { Component, Vue, Emit, Watch, Prop } from 'vue-property-decorator';
// components
import ExpandableCard from '../Shared/ExpandableCard.vue';
// interfaces
import { namespace } from 'vuex-class';
import { ExerciseVM } from '@/interfaces/ExerciseVM';
import { CourseElementVm } from '@/interfaces/CourseElementVm';
import { CourseElementType } from '@/interfaces/CourseElementType';
import { courseElementTypeItems } from "@/interfaces/Types";

const globals = namespace("globals");

@Component({
  components: {
    ExpandableCard,
  }
})
export default class RatingElementSettings extends Vue {
  // @Prop() element!: CourseElementVm;
  // @globals.Getter selectedExercise!: ExerciseVM;
  @globals.Getter selectedElement!: CourseElementVm | null;
  courseElementTypeItems = courseElementTypeItems;

  isBusy = false;

  mounted() {
  }

  getElementTitle(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.label : '';
  }

  getElementIcon(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.icon : '';
  }
}
